export default __webpack_public_path__ + "static/media/hero-img.0654bcdb.png";